// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"15451e30","238":"bc9494ff","247":"bef960ca","450":"bfab188a","453":"55444045","627":"cd50e013","653":"2691c260","768":"5012243c","834":"b23261b1","845":"2f1f96d9","923":"90b32055","938":"fb5c0914"}[chunkId] + ".chunk.js";
};